<template>
  <Teleport to="body">
  <Modal @close="$emit('close')">
    <div class="modal-header">
      <h2>Auto-post Deposits for {{ facility.name }}</h2>
    </div>
    <div class="p-3">
      <div v-if="facility.origin === 'PCC' && changeTo">
        <p>Zunta will automatically push deposits to PCC as soon as they appear in Zunta.</p>
        <p>Are you sure you would like to proceed?</p>
      </div>
      <div v-if="facility.origin === 'NCS' && changeTo">
        <p>Zunta will automatically mark deposits as posted in NCS as soon as they appear in Zunta.</p>
        <p>Are you sure you would like to proceed?</p>
      </div>
      <div v-if="facility.origin === 'PCC' && !changeTo">
        <p>Zunta will no longer automatically push deposits to PCC as soon as they appear in Zunta.</p>
        <p>Are you sure you would like to proceed?</p>
      </div>
      <div v-if="facility.origin === 'NCS' && !changeTo">
        <p>Zunta will no longer automatically mark deposits as posted in NCS as soon as they appear in Zunta.</p>
        <p>Are you sure you would like to proceed?</p>
      </div>

      <div class="text-right mt-3">
        <button @click="$emit('cancel')" class="button secondary mr-2">
          No
        </button>
        <button @click="confirm()" class="button primary">
          Yes
        </button>
      </div>
    </div>
  </Modal>
  </Teleport>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
// @ts-ignore
import Teleport from 'vue2-teleport'

@Component({
  props: {
    facility: {
      type: Object,
      required: true
    },
    changeTo: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Modal,
    Teleport
  }
})

export default class AutoPostDepositsModal extends Vue {
  confirm () {
    this.$emit('confirm', true)
  }
}
</script>

<style scoped lang="scss">

</style>
